import React, { useContext } from "react";
import "../styles/landingPage.css";
import "../styles/extraPages.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Navbar from "./navbar";

export default function AboutPage() {
    const { userData } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleCTA = () => {
        if (userData) {
            navigate("/home");
        } else {
            navigate("/auth");
        }
    };
    return (
        <div className="landingPageContainer">
            <div className="ambient-blob blob-1"></div>
            <div className="ambient-blob blob-2"></div>

            {/* Shared Navbar */}
            <Navbar />

            {/* Main Content */}
            <div className="extraPage-container">
                <div className="extraPage-hero">
                    <h1 className="extraPage-title">
                        About <span className="highlight-text">QuickMeet</span>
                    </h1>
                    <p className="extraPage-subtitle">
                        Empowering seamless connections — anywhere, anytime.
                    </p>
                </div>

                <div className="extraPage-cards">
                    <div className="extraPage-card">
                        <div className="extraPage-card-icon">🚀</div>
                        <h3>Our Mission</h3>
                        <p>
                            QuickMeet was built with one goal in mind — make video communication
                            effortless. We believe distance should never be a barrier to
                            meaningful collaboration.
                        </p>
                    </div>

                    <div className="extraPage-card">
                        <div className="extraPage-card-icon">🔒</div>
                        <h3>Privacy First</h3>
                        <p>
                            Your conversations are yours. We don't record, sell, or analyze
                            your meetings. End-to-end security is baked into every call.
                        </p>
                    </div>

                    <div className="extraPage-card">
                        <div className="extraPage-card-icon">⚡</div>
                        <h3>Lightning Fast</h3>
                        <p>
                            Powered by WebRTC, QuickMeet delivers ultra-low latency video and
                            audio so conversations feel natural and instant.
                        </p>
                    </div>

                    <div className="extraPage-card">
                        <div className="extraPage-card-icon">🌍</div>
                        <h3>Built for Everyone</h3>
                        <p>
                            Whether you're catching up with family or running a global team
                            standup, QuickMeet scales to your needs with a simple, intuitive
                            interface.
                        </p>
                    </div>
                </div>

                <div className="extraPage-cta">
                    <p>Ready to connect?</p>
                    <button className="ctaBtn" onClick={handleCTA}>
                        {userData ? "Go to Dashboard" : "Get Started Free"}
                    </button>
                </div>
            </div>
        </div>
    );
}
